angular.module('filters').filter('padStart', function() {
  return function(number, size) {
    var sign;
    sign = Math.sign(number) === -1 ? '-' : '';
    return sign + new Array(size).concat([Math.abs(number)]).join('0').slice(-size);
  };
});
